<template>
  <form
    id="cfgHyuSubmitForm"
    class="formCont"
    :action="dataBO.form.formUrl"
    method="post"
  >
    <input
      v-for="(field, i) in getFormFields"
      :key="i"
      type="hidden"
      :name="field.name"
      :id="field.name"
      :value="field.value"
    />
  </form>
</template>
<script>
import { formValidation } from "@/mixins/formValidation";
import { mapGetters } from "vuex";
import { cookiesFunc } from "../../../mixins/cookiesFunc";

export default {
  name: "FormCfgData",
  mixins: [formValidation, cookiesFunc],
  props: {
    content: {
      type: [Object, Array, PointerEvent, String],
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      formFieldsState: {},
    };
  },
  computed: {
    ...mapGetters({
      modelPrice: "resumeData/getFullPrice",
      getVersion: "versionsData/getVersionById",
    }),
    isCredOrHod() {
      if (!this.content?.carType) return false;
      return this.content.carType ? true : false;
    },
    getFormFields() {
      const resumeData = this.resumeData;
      const version = { ...this.getVersion(resumeData.versionID) };
      const userConfig = resumeData?.configSelected;
      const capitalToFinance = version.price - version.maxEntrance;

      const ctx = {
        id: "hyundai",
        cfg: "hyundai_configurator",
        sessionID: resumeData.sessionID,
        configurationID: resumeData.uniqueID,
        configurationPDF: "",
        utm_source: "",
        utm_medium: "",
        utm_campaign: "",
        utm_term: "",
        utm_content: "",
        modelName: resumeData.model,
        idModel: resumeData.modelid,
        idEngine: resumeData.engineID,
        engineName: userConfig?.motor.designation || "",
        powerCV: resumeData.power === 0 ? resumeData.powerKw : resumeData.power,
        idVersion: userConfig?.version?.id || "",
        versionName: userConfig?.version?.designation || "",
        idExterior: userConfig?.dsgExt?.colorid || "",
        exteriorColorName: userConfig?.dsgExt?.designation || "",
        exteriorColorPrice: userConfig?.dsgExt?.price
          ? parseFloat(userConfig.dsgExt.price).toFixed(2)
          : '',
        externalFactoryCode: userConfig?.dsgExt?.factoryCode || "",
        idInterior: userConfig?.dsgInt?.colorid || "",
        interiorName: userConfig?.dsgInt?.designation || "",
        interiorPrice: userConfig?.dsgInt?.price
          ? parseFloat(userConfig.dsgExt.price).toFixed(2)
          : '',
        internalFactoryCode: "",
        idVC: version.id || "",
        idGeneration: version.generation || "",
        localSuffix: version.localSuffix || "",
        localCode: version.localCode || "",
        totalPrice: this.modelPrice || "",
        basePrice: parseFloat(version?.price).toFixed(2) || "",
        nrPayments: version.nrPayments || "",
        initialValue: version.maxEntrance || "",
        taeg: version.taeg || "",
        rate: version.rate || "",
        capitalToFinance: capitalToFinance
          ? parseFloat(capitalToFinance).toFixed(2)
          : 0,
        mtic: version?.mtic || "",
        rent: version?.rent || "",
        fee: version?.rent || "",
        residualValue: version?.residualValue || "",
        creditType: "CRED",
        legalizationGain: version.legalizationGain || "",
        transportGain: version.transportGain || "",
      };

      const arr = Object.entries(ctx).map(([key, value]) => ({
        name: key,
        value: value,
      }));

      return arr;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./FormStyle.scss";
</style>
